import relicJson from "../content/relics.json";
import type { Relic } from "./types";

export type RelicDefinition = Pick<Relic, "id" | "name" | "description">;
export const relics = relicJson as RelicDefinition[];
export const FRAGMENTS_PER_RELIC = 5;

export type RelicProgress = { relicFragments: number; unlockedRelics: string[] };

export function relicCatalog(unlockedRelics: string[]): Relic[] {
  return relics.map(relic => ({
    ...relic,
    fragmentsRequired: FRAGMENTS_PER_RELIC,
    unlocked: unlockedRelics.includes(relic.id),
  }));
}

export function applyRelicFragments(progress: RelicProgress, fragments: number): {
  progress: RelicProgress;
  unlocked?: RelicDefinition;
} {
  let available = progress.relicFragments + fragments;
  const unlockedRelics = [...progress.unlockedRelics];
  let unlocked: RelicDefinition | undefined;
  if (available >= FRAGMENTS_PER_RELIC) {
    unlocked = relics.find(relic => !unlockedRelics.includes(relic.id));
    if (unlocked) {
      available -= FRAGMENTS_PER_RELIC;
      unlockedRelics.push(unlocked.id);
    }
  }
  return { progress: { relicFragments: available, unlockedRelics }, unlocked };
}
